import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/main.css';

// Error logger global
const logError = async (message, source) => {
  try {
    const { collection, addDoc, serverTimestamp } = await import('firebase/firestore');
    const { db } = await import('@config/firebase');
    await addDoc(collection(db, 'errorLogs'), {
      message: String(message).substring(0, 500),
      page: window.location.hash || '/',
      source: source || 'unknown',
      userAgent: navigator.userAgent.substring(0, 200),
      resolved: false,
      createdAt: serverTimestamp()
    });
  } catch (e) { /* silenciar errores del logger */ }
};

// Detecta el error de "chunk obsoleto": pasa cuando desplegamos una versión
// nueva mientras el usuario tiene la app abierta — el index.html viejo apunta
// a archivos JS con hash antiguo que ya no existen. Recargamos para coger la
// versión nueva, pero con un CONTADOR (máx 2) para no entrar en bucle si un
// chunk falla siempre (build corrupto, no por deploy). El contador se limpia
// cuando la app monta con éxito (lo hace App.jsx).
const isStaleChunkError = (msg) =>
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(msg || '');

const handleStaleChunk = () => {
  try {
    const count = parseInt(sessionStorage.getItem('chunkReloadCount') || '0', 10);
    if (count >= 2) return false; // ya reintentamos 2 veces, no insistir
    sessionStorage.setItem('chunkReloadCount', String(count + 1));
    window.location.reload();
    return true;
  } catch { return false; }
};

window.addEventListener('error', (e) => {
  if (isStaleChunkError(e.message)) { handleStaleChunk(); return; }
  if (e.message?.includes('ResizeObserver') || e.message?.includes('Script error')) return;
  logError(e.message, e.filename);
});

window.addEventListener('unhandledrejection', (e) => {
  const msg = e.reason?.message || e.reason?.toString() || 'Unhandled promise rejection';
  if (isStaleChunkError(msg)) { handleStaleChunk(); return; }
  if (msg.includes('auth') || msg.includes('permission')) return; // No loguear errores de auth normales
  logError(msg, 'promise');
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
